// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function() {
    const lazyImages = document.querySelectorAll("img[data-src]");
    
    function loadImage(img) {
        return new Promise((resolve, reject) => {
            const tempImage = new Image();
            tempImage.src = img.dataset.src;
            tempImage.onload = () => {
                img.src = img.dataset.src;
                img.removeAttribute('data-src');
                img.closest('.lazy-image').classList.add("loaded");
                resolve();
            };
            tempImage.onerror = reject;
        });
    }

    if ("IntersectionObserver" in window) {
        const lazyImageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    const lazyImage = entry.target;
                    loadImage(lazyImage).catch(console.error);
                    lazyImageObserver.unobserve(lazyImage);
                }
            });
        });

        lazyImages.forEach(function(lazyImage) {
            lazyImageObserver.observe(lazyImage);
        });
    } else {
        // Fallback para navegadores que no soportan IntersectionObserver
        lazyImages.forEach(function(lazyImage) {
            loadImage(lazyImage).catch(console.error);
        });
    }
});